import { render, staticRenderFns } from "./Changeshop.vue?vue&type=template&id=7889b245&scoped=true"
import script from "./Changeshop.vue?vue&type=script&lang=js"
export * from "./Changeshop.vue?vue&type=script&lang=js"
import style0 from "./Changeshop.vue?vue&type=style&index=0&id=7889b245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889b245",
  null
  
)

export default component.exports